import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitomahabaleshawarcab() {



  const cardData = {
    keyword: " Mumbai to Mahabaleshwar Cab",

headingDescription: "Royal Route Cab offers reliable and comfortable Mumbai to Mahabaleshwar cab services, ensuring a smooth and scenic journey to one of Maharashtra’s most popular hill stations. Whether you are planning a family vacation, romantic getaway, weekend trip, or group tour, our professional drivers and well-maintained vehicles guarantee a safe and relaxing travel experience. The Mumbai to Mahabaleshwar route covers approximately 260 to 280 km and takes you through beautiful highways, ghats, and lush green landscapes. We provide flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted choice for Mumbai to Mahabaleshwar travel.",

topPlaces: [
  {
    title: "Venna Lake",
    description: "Venna Lake is one of Mahabaleshwar’s most famous attractions, offering boating, horse riding, and beautiful scenic views. Surrounded by greenery, it is a perfect spot for families and couples to relax and enjoy nature."
  },
  {
    title: "Arthur’s Seat",
    description: "Arthur’s Seat is known as the Queen of all viewpoints in Mahabaleshwar. It offers breathtaking views of deep valleys and the Savitri River, making it a must-visit spot for photography and sightseeing."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden is a popular tourist attraction famous for its strawberry farms, fresh food products, and delicious shakes. Visitors can enjoy fresh strawberries and explore the beautiful garden surroundings."
  },
  {
    title: "Wilson Point",
    description: "Wilson Point is the highest point in Mahabaleshwar and is famous for sunrise and sunset views. Tourists visiting from Mumbai often come here early morning to witness the stunning sunrise over the hills."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is a beautiful natural attraction surrounded by dense forests. The waterfall is especially breathtaking during the monsoon season and is a favorite spot for nature lovers."
  },
  {
    title: "Pratapgad Fort",
    description: "Pratapgad Fort is a historic fort located near Mahabaleshwar, known for its association with Chhatrapati Shivaji Maharaj. It offers panoramic views and rich Maratha history."
  },
  {
    title: "Elephant’s Head Point",
    description: "Elephant’s Head Point is famous for its rock formation resembling an elephant’s head. It offers stunning valley views and is one of the most scenic viewpoints in Mahabaleshwar."
  },
  {
    title: "Panchgani Table Land",
    description: "Panchgani Table Land is one of Asia’s largest volcanic plateaus located near Mahabaleshwar. It is a popular spot for horse riding, sightseeing, and enjoying panoramic views."
  },
  {
    title: "Kate’s Point",
    description: "Kate’s Point offers breathtaking views of the Krishna Valley and Dhom Dam. It is a peaceful and scenic spot ideal for photography and nature lovers."
  },
  {
    title: "Bombay Point",
    description: "Bombay Point, also known as Sunset Point, is famous for its spectacular sunset views. Tourists traveling from Mumbai often visit here to enjoy the golden sky and cool breeze."
  }
],

whychoose: [
  {
    WhyChooseheading: "Comfortable Hill Station Travel",
    WhyChoosedescription: "Royal Route Cabs offers smooth and comfortable Mumbai to Mahabaleshwar cab services, perfect for family trips, weekend getaways, and hill station vacations."
  },
  {
    WhyChooseheading: "Experienced Ghat Drivers",
    WhyChoosedescription: "Our drivers are experienced in driving through ghat roads and hilly terrain, ensuring safe and secure travel to Mahabaleshwar."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "We provide clear and upfront pricing for Mumbai to Mahabaleshwar cab bookings with no hidden charges, including tolls and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Availability",
    WhyChoosedescription: "Our cab service is available 24/7, allowing you to plan early morning departures or late-night journeys as per your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "All our vehicles are well-maintained, sanitized, and air-conditioned to ensure a comfortable journey through long scenic routes."
  },
  {
    WhyChooseheading: "Flexible Booking Options",
    WhyChoosedescription: "We offer one-way, round-trip, and customized travel packages from Mumbai to Mahabaleshwar based on your travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Choices",
    WhyChoosedescription: "Choose from sedans, SUVs like Ertiga and Innova, Innova Crysta, luxury cars, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Service",
    WhyChoosedescription: "Royal Route Cab is trusted by thousands of travelers for safe, punctual, and comfortable Mumbai to Mahabaleshwar journeys."
  }
],

faqData: [
  {
    question: "Do you provide Mumbai to Mahabaleshwar cab service?",
    answer: "Yes, Royal Route Cab provides reliable cab services from Mumbai to Mahabaleshwar for one-way and round trips."
  },
  {
    question: "How far is Mahabaleshwar from Mumbai?",
    answer: "The distance is approximately 260 to 280 km and takes around 5 to 6 hours depending on traffic and route."
  },
  {
    question: "Is cab service available 24/7?",
    answer: "Yes, our Mumbai to Mahabaleshwar cab service is available 24/7."
  },
  {
    question: "Can I book a one-way cab?",
    answer: "Yes, we provide both one-way and round-trip cab options."
  },
  {
    question: "Are vehicles suitable for ghat driving?",
    answer: "Yes, all our vehicles are well-maintained and our drivers are experienced in hill and ghat driving."
  },
  {
    question: "Do you provide doorstep pickup?",
    answer: "Yes, we offer pickup from home, hotel, or office anywhere in Mumbai."
  },
  {
    question: "Are vehicles air-conditioned?",
    answer: "Yes, all vehicles are fully air-conditioned for a comfortable journey."
  },
  {
    question: "Can I book online?",
    answer: "Yes, you can easily book your Mumbai to Mahabaleshwar cab online or via phone."
  },
  {
    question: "Is advance booking required?",
    answer: "Advance booking is recommended, especially during weekends and holiday seasons."
  },
  {
    question: "Are vehicles sanitized?",
    answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety."
  }
],

testimonials: [
  {
    id: 1,
    name: "Mr. Suresh Patil",
    feedback: "Very smooth journey from Mumbai to Mahabaleshwar. Driver was professional and car was clean.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Deshmukh",
    feedback: "Excellent service for our family trip. Comfortable ride and timely pickup.",
    rating: 5
  }
],



services: [
  {
    name: "Mumbai to Mahabaleshwar Cab",
    description: "Mumbai to Mahabaleshwar cab service offers a comfortable and scenic journey to one of Maharashtra’s most popular hill stations. This route is known for its beautiful ghats, greenery, and refreshing climate, making the road trip enjoyable. Ideal for families, couples, and groups, the service ensures safe and smooth travel with experienced drivers. Customers can choose from multiple vehicle options based on their comfort and budget. Flexible pickup across Mumbai adds convenience. It guarantees a relaxing and memorable travel experience."
  },
  {
    name: "Mumbai to Mahabaleshwar Taxi",
    description: "Mumbai to Mahabaleshwar taxi provides reliable and hassle-free transportation for travelers planning a hill station trip. With well-maintained vehicles and professional drivers, this service ensures a safe journey through winding ghat roads. Door-to-door pickup and drop enhance convenience. It is suitable for weekend getaways, family vacations, and corporate trips. Travelers can enjoy flexible travel timings and comfortable seating. It ensures a stress-free travel experience."
  },
  {
    name: "Mumbai to Mahabaleshwar Cab Service",
    description: "Mumbai to Mahabaleshwar cab service is designed for long-distance comfort with a focus on safety and punctuality. This service caters to tourists and business travelers seeking reliable intercity travel. Vehicles are regularly serviced for smooth highway and ghat performance. Flexible travel plans and multiple pickup points make it convenient. Customers can choose sedan, SUV, or luxury cars. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Mumbai to Mahabaleshwar Taxi Fare",
    description: "Mumbai to Mahabaleshwar taxi fare is structured to provide transparent and budget-friendly pricing for travelers. Fare depends on vehicle type, trip duration, and travel requirements. Customers receive clear cost breakdown without hidden charges. Options are available for sedan, SUV, and premium vehicles. It helps travelers plan their trip cost effectively. It offers great value for a long-distance journey."
  },
  {
    name: "Cab from Mumbai to Mahabaleshwar",
    description: "Cab from Mumbai to Mahabaleshwar ensures a comfortable and private journey with flexible travel options. This service is ideal for those who prefer personalized travel with stops along the route. Clean vehicles and experienced drivers enhance safety and comfort. Suitable for families, couples, and groups. It offers a relaxed and enjoyable road trip experience. Easy booking adds convenience."
  },
  {
    name: "Taxi from Mumbai to Mahabaleshwar",
    description: "Taxi from Mumbai to Mahabaleshwar offers convenient and dependable travel for tourists visiting this scenic hill destination. Drivers are experienced in ghat driving ensuring safe navigation. Vehicles provide comfortable seating for long journeys. Door-to-door service makes travel easy. It is suitable for both short vacations and extended stays. It ensures a pleasant and reliable journey."
  },
  {
    name: "Mumbai to Mahabaleshwar Cab Booking",
    description: "Mumbai to Mahabaleshwar cab booking allows travelers to reserve their ride easily with flexible options. Customers can select vehicle type, pickup location, and travel date as per their needs. Instant confirmation and transparent pricing ensure a hassle-free process. Online and offline booking options are available. Dedicated support helps throughout the journey. It is the easiest way to plan your trip."
  },
  {
    name: "Mumbai to Mahabaleshwar Taxi Booking Online",
    description: "Mumbai to Mahabaleshwar taxi booking online provides a quick and convenient way to book your travel in minutes. Secure payment options and instant confirmations make it user-friendly. Customers can compare vehicle types and pricing easily. This service ensures availability during peak seasons. Flexible scheduling adds comfort. It simplifies your travel planning experience."
  },
  {
    name: "Mumbai to Mahabaleshwar Cab Price",
    description: "Mumbai to Mahabaleshwar cab price varies depending on vehicle category, travel duration, and trip type. Transparent pricing ensures no hidden costs for customers. Budget-friendly and premium options are available to suit different needs. Customers can choose from sedan, SUV, and luxury cars. It helps travelers select the best option within their budget. It ensures value-driven travel."
  },
  {
    name: "Mumbai to Mahabaleshwar Taxi Charges",
    description: "Mumbai to Mahabaleshwar taxi charges are designed to be competitive and transparent for all travelers. Charges may include tolls, driver allowance, and distance-based fare. Customers are provided with clear pricing details in advance. Affordable options are available for various vehicle types. It helps in easy trip planning. It ensures a cost-effective journey."
  },
  {
    name: "Mumbai to Mahabaleshwar One Way Cab",
    description: "Mumbai to Mahabaleshwar one way cab is a cost-efficient option for travelers needing a single-side drop. This service eliminates return charges, making it budget-friendly. Ideal for those planning to stay in Mahabaleshwar. Flexible pickup timings and comfortable vehicles enhance convenience. Professional drivers ensure safe travel. It is perfect for economical travel."
  },
  {
    name: "Mumbai to Mahabaleshwar Round Trip Taxi",
    description: "Mumbai to Mahabaleshwar round trip taxi is ideal for travelers planning a return journey after their visit. This package includes pickup, drop, waiting time, and return travel. Flexible schedules allow travelers to enjoy their trip without stress. Multiple vehicle options cater to families and groups. Professional drivers ensure timely service. It offers convenience and cost efficiency."
  },
  {
    name: "Mumbai to Mahabaleshwar Innova Cab",
    description: "Mumbai to Mahabaleshwar Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating, luggage space, and smooth performance on ghat roads. Ideal for long-distance journeys and vacations. Professional drivers ensure safety and reliability. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Mahabaleshwar Ertiga Cab",
    description: "Mumbai to Mahabaleshwar Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers good mileage and comfortable seating. It is ideal for budget-friendly long-distance travel. Drivers ensure safe driving throughout the journey. It ensures a smooth and enjoyable experience."
  },
  {
    name: "Mumbai to Mahabaleshwar Sedan Cab",
    description: "Mumbai to Mahabaleshwar sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving, comfortable seating, and fuel efficiency. This option is popular for its affordability and convenience. Professional drivers ensure safe travel on highways and ghats. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Mahabaleshwar SUV Taxi",
    description: "Mumbai to Mahabaleshwar SUV taxi is ideal for travelers who need extra space and comfort. SUVs perform well on ghat roads and provide better stability during long drives. Suitable for families and group travel. Drivers are trained for long-distance routes ensuring safety. It delivers a comfortable and powerful travel experience."
  },
  {
    name: "Mumbai to Mahabaleshwar Luxury Cab",
    description: "Mumbai to Mahabaleshwar luxury cab offers a premium travel experience with high-end vehicles and superior comfort. Ideal for business executives, couples, and special occasions. Vehicles feature spacious interiors and advanced amenities. Professional chauffeurs ensure a smooth journey. It is perfect for a luxurious hill station trip."
  },
  {
    name: "Mumbai to Mahabaleshwar Family Cab",
    description: "Mumbai to Mahabaleshwar family cab is designed for comfortable group travel with spacious seating and safety features. This service is ideal for family vacations and group outings. Vehicles provide ample luggage space and smooth travel experience. Professional drivers ensure a safe journey for all passengers. It guarantees a relaxed and enjoyable family trip."
  }
],

tableData: [
  ["Mumbai to Mahabaleshwar Cab", "Mumbai to Mahabaleshwar Taxi"],
  ["Mumbai to Mahabaleshwar Cab Service", "Mumbai to Mahabaleshwar Taxi Fare"],
  ["Cab from Mumbai to Mahabaleshwar", "Taxi from Mumbai to Mahabaleshwar"],
  ["Mumbai to Mahabaleshwar Cab Booking", "Mumbai to Mahabaleshwar Taxi Booking Online"],
  ["Mumbai to Mahabaleshwar Cab Price", "Mumbai to Mahabaleshwar Taxi Charges"],
  ["Mumbai to Mahabaleshwar One Way Cab", "Mumbai to Mahabaleshwar Round Trip Taxi"],
  ["Mumbai to Mahabaleshwar Innova Cab", "Mumbai to Mahabaleshwar Ertiga Cab"],
  ["Mumbai to Mahabaleshwar Sedan Cab", "Mumbai to Mahabaleshwar SUV Taxi"],
  ["Mumbai to Mahabaleshwar Luxury Cab", "Mumbai to Mahabaleshwar Family Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Mahabaleshwar Travel",
    WhyChoosedescription: "Royal Route Cabs provides a smooth and comfortable Mumbai to Mahabaleshwar cab service, perfect for weekend getaways, family trips, and hill station travel."
  },
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained for ghat and hill driving routes, ensuring safe navigation through winding roads and a secure journey to Mahabaleshwar."
  },
  {
    WhyChooseheading: "Transparent Pricing Structure",
    WhyChoosedescription: "Royal Route Cabs offers clear and upfront pricing for Mumbai to Mahabaleshwar cab bookings, including tolls and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our cab services are available 24/7, allowing you to plan your Mumbai to Mahabaleshwar trip anytime with flexible pickup options."
  },
  {
    WhyChooseheading: "Clean & Hygienic AC Vehicles",
    WhyChoosedescription: "All our vehicles are air-conditioned, well-maintained, and regularly sanitized to ensure a comfortable and relaxing travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose flexible travel options including one-way cab service, round-trip bookings, or customized Mahabaleshwar travel packages."
  },
  {
    WhyChooseheading: "Multiple Vehicle Choices",
    WhyChoosedescription: "Select from a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, luxury cars, and Tempo Travellers for group trips."
  },
  {
    WhyChooseheading: "Trusted Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Mahabaleshwar cab bookings due to punctual service, professional drivers, and customer satisfaction."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Mahabaleshwar cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Mahabaleshwar for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Mahabaleshwar?", answer: "The distance is approximately 260 to 280 km and takes around 5 to 7 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Mahabaleshwar cab service is available 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, luxury cars, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide hotel or home pickup?", answer: "Yes, we offer doorstep pickup from homes, hotels, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and holiday seasons." },
  { question: "Is the route safe for travel?", answer: "Yes, our experienced drivers ensure safe travel, especially on ghat sections of the Mahabaleshwar route." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket Joshi",
    feedback: "The Mumbai to Mahabaleshwar cab service with Royal Route Cabs was very smooth and enjoyable. The hill journey was comfortable and the driver handled the roads safely.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback: "Excellent experience traveling from Mumbai to Mahabaleshwar. The cab was clean, the ride was relaxing, and the entire trip felt well-managed and stress-free.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Mahabaleshwar Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-mahabaleshwar-cab.jpg", // replace if needed
  "description": "Book Mumbai to Mahabaleshwar cab with Royal Route Cabs for a comfortable and affordable journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel with experienced drivers and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-mahabaleshwar-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Mahabaleshwar Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Mahabaleshwar cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to mahabaleshwar cab, mumbai to mahabaleshwar taxi, mumbai to mahabaleshwar cab service, mumbai to mahabaleshwar taxi fare, cab from mumbai to mahabaleshwar, taxi from mumbai to mahabaleshwar, mumbai to mahabaleshwar cab booking, mumbai to mahabaleshwar taxi booking online, mumbai to mahabaleshwar cab price, mumbai to mahabaleshwar taxi charges, mumbai to mahabaleshwar one way cab, mumbai to mahabaleshwar round trip taxi, mumbai to mahabaleshwar innova cab, mumbai to mahabaleshwar ertiga cab, mumbai to mahabaleshwar sedan cab, mumbai to mahabaleshwar suv taxi, mumbai to mahabaleshwar luxury cab, mumbai to mahabaleshwar family cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitomahabaleshawarcab;